/**
 * Block Account + SMA read-only view (Sweet Futures demo, 2026-07-22).
 *
 * Entirely static demo data — see @/utils/demoBlockAccounts. No API calls,
 * no store. Read-only: no actions are wired up.
 */

import clsx from "clsx";
import { DEMO_BLOCK_ACCOUNT } from "@/utils/demoBlockAccounts";
import { formatCurrency, formatReturn } from "@/utils/format";

export default function Accounts() {
  const { name, accountNumber, balance, smas } = DEMO_BLOCK_ACCOUNT;

  return (
    <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-8">
      <title>Accounts | Sovrun</title>
      <h1 className="mb-6 text-2xl font-bold text-slate-900">Accounts</h1>

      {/* Block Account Header Card */}
      <div className="rounded-xl border border-slate-700 bg-slate-800 p-5">
        <p className="text-xs font-medium uppercase tracking-wider text-slate-500">
          Block Account
        </p>
        <h2 className="mt-1 text-lg font-semibold text-white">{name}</h2>
        <p className="mt-1 text-sm text-slate-400">Account #{accountNumber}</p>
        <p className="mt-3 text-2xl font-bold text-white">
          {formatCurrency(balance, 0)}
        </p>
      </div>

      {/* SMA Rows */}
      <div className="mt-8 space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-slate-900">Sub-Managed Accounts</h2>
          <span className="text-sm text-slate-500">
            {smas.length} {smas.length === 1 ? "SMA" : "SMAs"}
          </span>
        </div>

        <div className="overflow-x-auto rounded-xl border border-slate-700 bg-slate-800">
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="border-b border-slate-700 bg-slate-800/50 text-xs uppercase tracking-wider text-slate-500">
                <th className="px-4 py-3 font-medium">SMA</th>
                <th className="px-4 py-3 font-medium">Balance</th>
                <th className="px-4 py-3 font-medium">Strategies</th>
                <th className="px-4 py-3 font-medium">MTD Return</th>
              </tr>
            </thead>
            <tbody>
              {smas.map((sma) => (
                <tr
                  key={sma.id}
                  className="border-b border-slate-800 bg-slate-800/30 last:border-b-0"
                >
                  <td className="px-4 py-3 font-medium text-white">{sma.name}</td>
                  <td className="px-4 py-3 text-slate-300">
                    {formatCurrency(sma.balance, 0)}
                  </td>
                  <td className="px-4 py-3 text-slate-300">{sma.strategyCount}</td>
                  <td
                    className={clsx(
                      "px-4 py-3 font-medium",
                      sma.mtdReturnPercent >= 0 ? "text-emerald-400" : "text-rose-400"
                    )}
                  >
                    {formatReturn(sma.mtdReturnPercent, 2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
